var main_nav = (function( $ ) {

	var init = function() {
		toggle_dropdown();
		close_dropdown_on_click_outside();
		close_dropdown();
	};

	var toggle_dropdown = function() {
		$( '.menu-item-has-children > a' ).on( 'click', handle_dropdown_click );
		$( '.subscribe-links' ).on( 'click', handle_dropdown_click );
	};

	var handle_dropdown_click = function( event ) {
		var $clicked_link = $( this );
		var $closest_li = $clicked_link.closest('li');

		if ($closest_li.hasClass('menu-item-has-children')) {
			if (window.innerWidth >= 1200) {
				event.preventDefault();
			}
		}

		var $submenu_container = $closest_li.find('.submenu-container');

		if ($submenu_container.is(event.target) || $submenu_container.has(event.target).length) {
			return;
		}

		var is_open = $submenu_container.hasClass('open');
		var is_active = $clicked_link.hasClass('active');

		$( '.menu-item-has-children > a' ).removeClass( 'active' );
		$( '.submenu-container.open' ).removeClass( 'sf-mega clearfix open' ).css( 'display', 'none' );

		if (!is_open || !is_active) {
			$clicked_link.addClass( 'active' );
			$submenu_container.addClass( 'sf-mega clearfix open' ).css( 'display', 'block' );
		} else {
			if ($clicked_link.is('li')) {
				$clicked_link.find('a').blur();
			} else {
				$clicked_link.blur();
			}
		}

		event.stopPropagation();
	};

	var close_dropdown_on_click_outside = function() {
		$( document ).on( 'click', function( event ) {
			if ( ! $( event.target ).closest( '.submenu-container' ).length && ! $( event.target ).closest( '.sf-mega' ).length ) {
				$( '.submenu-container.open' ).removeClass( 'sf-mega clearfix open' ).css( 'display', 'none' );
				$( '.menu-item-has-children > a' ).removeClass( 'active' );
			}
		} );
	};

	var close_dropdown = function() {
		$( '.close-submenu-icon' ).on( 'click', function( event ) {
			var $submenu_container = $( this ).closest( '.submenu-container' );
			$submenu_container.removeClass( 'sf-mega clearfix open' ).css( 'display', 'none' );
			$submenu_container.closest( 'li' ).find( '> a' ).removeClass( 'active' );
			event.stopPropagation();
		} );
	};

	$( document ).ready( init );

	return {};

})( jQuery );

module.exports = main_nav;